<template>
  <div
    class="workbench-sequence color-4 t-rounded t-shadow font-weight-light"
    >
    <div class="workbench-sequence-info t-rounded t-shadow">
      <div class="workbench-sequence-info-header">
        <slot name="info-header"/>
      </div>
      <div class="workbench-sequence-info-content">
        <slot name="info-content"/>
      </div>
      <div class="workbench-sequence-info-footer">
        <slot name="info-footer"/>
      </div>
    </div>
    <div class="workbench-sequence-content pb-1 pt-1">
      <div class="workbench-sequence-content-statistics">
        <slot name="content-statistics"/>
      </div>
      <div class="workbench-sequence-content-body">
        <slot name="content-sequence"/>
      </div>
    </div>
  </div>
</template>
<script>
  export default {
    props: [],
  }
</script>
<style>
  .workbench-sequence {
    display: flex;
    width: 100%;
    height: 128px;
    margin: 4px;
    overflow: hidden;
  }
  .workbench-sequence-info {
    width: 192px;
    height: 100%;
    background-color: var(--v-color-2-5-base);
  }
  .workbench-sequence-info-header {
    position: relative;
    display: flex;
    width: 100%;
    height: 33px;
    user-select: none;
    align-items: center;
    margin-left: 3px;
  }
  .workbench-sequence-info-content{
    display: flex;
    height: calc(100% - 33px - 30px);
    flex-direction: column;
    justify-content: center;
    padding: 3px;
    z-index: 0;
  }
  .workbench-sequence-info-footer{
    display: flex;
    height: 30px;
    flex-direction: column;
    padding: 3px;
    z-index: 0;
    font-size: 12px;
    line-height: 13px;
    user-select: none;
  }
  .workbench-sequence-content {
    position: relative;
    width: calc(100% - 192px);
    height: 100%;
    overflow: auto;
  }
  .workbench-sequence-content-statistics {
    display: flex;
    height: calc(100% - 42px)
  }
  .workbench-sequence-content-body {
    display: flex;
    height: 42px;
  }
</style>
